// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3HKDR","label":"Completed_label__2Spm3"};